import { GatewayProvider } from '@civic/solana-gateway-react';
import { useWallet } from '@solana/wallet-adapter-react';
import { Connection, PublicKey } from '@solana/web3.js';
import React, { useMemo, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getPortalConfig, PortalConfig } from '../common/config';
import { clusterEndpoint } from '../common/config/solana';
import MainContainer from '../common/MainContainer/MainContainer';
import TokenStatusPanel from '../common/TokenStatus/TokenStatusPanel';

export default function TokenStatusScreen(): JSX.Element {
  const [config] = useState<PortalConfig>(getPortalConfig());
  const adapter = useWallet();

  const connection = useMemo(() => {
    return new Connection(clusterEndpoint(config.network), 'processed');
  }, [config.network]);

  return (
    <MainContainer>
      <>
        {adapter.wallet && adapter.connected && (
          <GatewayProvider
            wallet={adapter}
            cluster={config.network}
            connection={connection}
            stage={config.gatewayStage}
            gatekeeperNetwork={new PublicKey(config.gatekeeperNetworkPublicKey)}
            gatekeeperSendsTransaction={!config.useClientSends}
          >
            <div className="main-panel">
              <TokenStatusPanel />
            </div>
          </GatewayProvider>
        )}
      </>
    </MainContainer>
  );
}
